import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

function Label({
  label,
  disabled,
  required,
  info,
  className,
}) {
  return (
    <div className={classNames('label', { disabled }, className)}>
      <span className="label-text">
        {label}
      </span>
      {required && <span className="label-required">*</span>}
      {info && <span className="bl-info-tooltip-fill label-info">{info}</span>}
    </div>
  );
}

Label.propTypes = {
  label: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  required: PropTypes.bool,
  info: PropTypes.string,
  className: PropTypes.string,
};

Label.defaultProps = {
  disabled: false,
  required: false,
  info: '',
  className: '',
};

export default Label;
